import { categoryList } from '@/store/dict/rentPlanDict'
import SelectOption from '@/store/dict/selectOptionDict'
import { TEMPLATE_STATE } from '@/store/dict/templateDict.js'
import { PLAN_TYPE_TEXT } from '../../const'

export const STATE_ENUM = {
  ABLE: 1, // 可用
  DISABLE: 0, // 不可用
}

export const DIALOG_CONFIG = {
  [STATE_ENUM.ABLE]: {
    title: '下架租赁方案',
    contentTxt: '确认下架该租赁方案',
    sureBtnText: '确定',
  },
  [STATE_ENUM.DISABLE]: {
    title: '上架租赁方案',
    contentTxt: '确认上架该租赁方案',
    sureBtnText: '确定',
  },
}

// 0: '上架', 1: '下架'
export const STATE_ENUM_TEXT = {
  [STATE_ENUM.ABLE]: '下架',
  [STATE_ENUM.DISABLE]: '上架',
}
export const TYPE_ENUM = {
  ADDOREDIT: 1, // 可用
  DELETE: -1, // 删除
}

export default function () {
  const tableColumns = [
    {
      label: '方案所属城市',
      key: 'showCityCodes',
      width: 160,
      ellipsis: true,
      ellipsisNum: 1,
      formatter: (_, row) => {
        if (row.showCityCodes?.length === 0) return '--'
        if (row.showCityCodes.length === 1) {
          return row.showCityCodes?.[0]
        }
        return row.showCityCodes.join(',')
      },
    },
    {
      label: '方案名称',
      key: 'name',
      width: 160,
    },
    {
      label: '品牌',
      key: 'brandName',
    },
    {
      label: '车系',
      key: 'seriesName',
    },
    {
      label: '车型',
      key: 'modelName',
      width: 160,
    },
    {
      label: '方案类型',
      key: 'typeId',
      width: 120,
      formatter: (_, row) => {
        const type = PLAN_TYPE_TEXT[row.orderType]
        return type ? `${type}租赁方案` : '--'
      },
    },
    {
      label: '租赁类型',
      key: 'rentCategory',
      with: 120,
      formatter: (_, row) => {
        return categoryList[row.rentCategory] || '--'
      },
    },
    {
      label: '合同模板名称',
      key: 'templateName',
      width: 160,
    },
    {
      label: '合同状态',
      key: 'templateState',
      width: 120,
      formatter: (_, row) => TEMPLATE_STATE[row.templateState] || '--',
    },
    {
      label: '方案状态',
      key: 'state',
      source: SelectOption.leasingSchemeState,
    },
    {
      label: '租期',
      key: 'rentPeriod',
      formatter: (_, row) => {
        if (row.rentPeriodType === 1) {
          return `${row.rentPeriod}天`
        }
        if (row.rentPeriodType === 3) {
          return `${row.rentPeriod}个月`
        }
        return '--'
      },
    },
    {
      label: '每期租金(元)',
      key: 'rentAmount',
      width: 100,
    },
    {
      label: '押金(元)',
      key: 'deposit',
      formatter: (_, row) => {
        if (!row.deposit) {
          return '--'
        }
        return this.numberWithCommas(row.deposit)
      },
    },
  ]

  const buttons = [
    {
      label: (row) => {
        return STATE_ENUM_TEXT[row.state]
      },
      show: () => this.judgePermission('for_rent_config_ren_plan_up_and_down'),
      clickFn: this.clickHandle,
      params: { type: TYPE_ENUM.ADDOREDIT },
    },
    {
      label: '编辑',
      // 下架并且有权限
      show: (row) => {
        const { state, orderType } = row
        // 个人租赁方案上架状态也允许编辑
        const hasPermission = this.judgePermission('for_rent_config_ren_plan_edit')
        if (orderType === 1) {
          return hasPermission
        }
        return state === STATE_ENUM.DISABLE && hasPermission
      },
      clickFn: (row) => {
        this.goEditPage(row)
      },
    },
    {
      label: '复制',
      show: () => this.judgePermission('for_rent_config_ren_plan_copy'),
      clickFn: (row) => {
        this.copy(row)
      },
    },
  ]
  const urlMap = {
    // 工作台-个人租赁订单
    workbench_rent_order: {
      1: {
        path: '/workbench/rentOrder/list',
        query: {},
      }, // 个人订单
      2: {
        path: '/workbench/entOrder/list',
        query: {
          activeName: 'child',
        },
      }, // 企业子订单
    },
    // 待租-签约提车
    for_rent_sign_contract: {
      1: {
        path: '/car_to_lease/forRentSignContract', // 个人订单
        query: {},
      },
      2: {
        path: '/car_to_lease/forRentSignContract', // 企业子订单
        query: {
          activeName: 'child',
        },
      },
    },
  }
  return {
    tableColumns,
    buttons,
    urlMap,
  }
}
